import { render, staticRenderFns } from "./NewLeadModal.vue?vue&type=template&id=0bedc1b0"
import script from "./NewLeadModal.vue?vue&type=script&lang=js"
export * from "./NewLeadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports